/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreatePersonalAssetScheduledDto,
    CreatePersonalAssetScheduledDtoFromJSON,
    CreatePersonalAssetScheduledDtoToJSON,
    PersonalAssetScheduledDto,
    PersonalAssetScheduledDtoFromJSON,
    PersonalAssetScheduledDtoToJSON,
    UpdatePersonalAssetScheduledDto,
    UpdatePersonalAssetScheduledDtoFromJSON,
    UpdatePersonalAssetScheduledDtoToJSON,
} from '../models';

export interface PersonalAssetScheduledControllerCreateRequest {
    createPersonalAssetScheduledDto: CreatePersonalAssetScheduledDto;
}

export interface PersonalAssetScheduledControllerDeleteRequest {
    id: string;
}

export interface PersonalAssetScheduledControllerGetRequest {
    id: string;
}

export interface PersonalAssetScheduledControllerGetListRequest {
    personalAssetId: string;
}

export interface PersonalAssetScheduledControllerUpdateRequest {
    id: string;
    updatePersonalAssetScheduledDto: UpdatePersonalAssetScheduledDto;
}

/**
 * 
 */
export class PersonalAssetsScheduledApi extends runtime.BaseAPI {

    /**
     * Create personal asset scheduled
     */
    async personalAssetScheduledControllerCreateRaw(requestParameters: PersonalAssetScheduledControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetScheduledDto>> {
        if (requestParameters.createPersonalAssetScheduledDto === null || requestParameters.createPersonalAssetScheduledDto === undefined) {
            throw new runtime.RequiredError('createPersonalAssetScheduledDto','Required parameter requestParameters.createPersonalAssetScheduledDto was null or undefined when calling personalAssetScheduledControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-scheduled`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePersonalAssetScheduledDtoToJSON(requestParameters.createPersonalAssetScheduledDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetScheduledDtoFromJSON(jsonValue));
    }

    /**
     * Create personal asset scheduled
     */
    async personalAssetScheduledControllerCreate(requestParameters: PersonalAssetScheduledControllerCreateRequest, initOverrides?: RequestInit): Promise<PersonalAssetScheduledDto> {
        const response = await this.personalAssetScheduledControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove personal asset scheduled
     */
    async personalAssetScheduledControllerDeleteRaw(requestParameters: PersonalAssetScheduledControllerDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetScheduledControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-scheduled/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Remove personal asset scheduled
     */
    async personalAssetScheduledControllerDelete(requestParameters: PersonalAssetScheduledControllerDeleteRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.personalAssetScheduledControllerDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get array of personal asset
     */
    async personalAssetScheduledControllerGetRaw(requestParameters: PersonalAssetScheduledControllerGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetScheduledDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetScheduledControllerGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-scheduled/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetScheduledDtoFromJSON(jsonValue));
    }

    /**
     * Get array of personal asset
     */
    async personalAssetScheduledControllerGet(requestParameters: PersonalAssetScheduledControllerGetRequest, initOverrides?: RequestInit): Promise<PersonalAssetScheduledDto> {
        const response = await this.personalAssetScheduledControllerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get array of personal asset scheduled entries
     */
    async personalAssetScheduledControllerGetListRaw(requestParameters: PersonalAssetScheduledControllerGetListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<PersonalAssetScheduledDto>>> {
        if (requestParameters.personalAssetId === null || requestParameters.personalAssetId === undefined) {
            throw new runtime.RequiredError('personalAssetId','Required parameter requestParameters.personalAssetId was null or undefined when calling personalAssetScheduledControllerGetList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-scheduled/list/{personalAssetId}`.replace(`{${"personalAssetId"}}`, encodeURIComponent(String(requestParameters.personalAssetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonalAssetScheduledDtoFromJSON));
    }

    /**
     * Get array of personal asset scheduled entries
     */
    async personalAssetScheduledControllerGetList(requestParameters: PersonalAssetScheduledControllerGetListRequest, initOverrides?: RequestInit): Promise<Array<PersonalAssetScheduledDto>> {
        const response = await this.personalAssetScheduledControllerGetListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update personal asset scheduled
     */
    async personalAssetScheduledControllerUpdateRaw(requestParameters: PersonalAssetScheduledControllerUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetScheduledDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetScheduledControllerUpdate.');
        }

        if (requestParameters.updatePersonalAssetScheduledDto === null || requestParameters.updatePersonalAssetScheduledDto === undefined) {
            throw new runtime.RequiredError('updatePersonalAssetScheduledDto','Required parameter requestParameters.updatePersonalAssetScheduledDto was null or undefined when calling personalAssetScheduledControllerUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-scheduled/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePersonalAssetScheduledDtoToJSON(requestParameters.updatePersonalAssetScheduledDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetScheduledDtoFromJSON(jsonValue));
    }

    /**
     * Update personal asset scheduled
     */
    async personalAssetScheduledControllerUpdate(requestParameters: PersonalAssetScheduledControllerUpdateRequest, initOverrides?: RequestInit): Promise<PersonalAssetScheduledDto> {
        const response = await this.personalAssetScheduledControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
